import {Button, TextInput} from 'platform/components';
import {HStack, Hide, VStack} from 'platform/foundation';

import {isNil} from 'ramda';

import {useGetTreeFolderPathQuery} from '@dms/api/core';
import i18n from '@dms/i18n';

import {suffixTestId, Nullish, TestIdProps} from 'shared/web';

interface TreeFolderPathProps extends TestIdProps {
  leafId: string | Nullish;
  onEdit?: VoidFunction;
}

export function TreeFolderPath(props: TreeFolderPathProps) {
  const {data} = useGetTreeFolderPathQuery(
    {leafId: props.leafId ?? ''},
    {skip: isNil(props.leafId)}
  );

  return (
    <VStack>
      <TextInput
        value={data?.treeFolder?.pathName ?? null}
        isDisabled
        label={i18n.t('general.labels.category')}
        data-testid={suffixTestId('treeFolderPathInput', props)}
      />
      <Hide when={isNil(props.onEdit)}>
        <HStack>
          <Button
            variant="link"
            onClick={props.onEdit}
            title={i18n.t('general.labels.editCategory')}
            leftIcon="image/edit"
            data-testid={suffixTestId('editCategory', props)}
          />
        </HStack>
      </Hide>
    </VStack>
  );
}
